<div role="alert" [ngClass]="hasError ? 'text-failure' : 'text-success'">
  <span
    alt="Green Checkbox"
    class="material-icons login-icon success"
    *ngIf="!hasError"
    aria-hidden="true"
    >check_circle</span
  >
  <span class="sr-only" *ngIf="!hasError">Success</span>
  <span class="sr-only" *ngIf="hasError">Action Required</span>
  <span
    class="material-icons login-icon failure"
    *ngIf="hasError"
    aria-hidden="true"
    >cancel_outline</span
  >
  <ng-content></ng-content>
</div>
